<span class="main-wrapper"> Please wait.. your layout is being prepared..</span>
